<template lang="pug">
    .menu
        ul.menu__list
            li.menu__item(v-for='(item, index) in menudata')
                a.menu__item-link(:href='`#${item.link}`', @click='() => $emit("closemenu")', :class='{animate: pageLoaded}')
                    span.menu__item-text(v-html='item.text')

            li.menu__item
                .menu__item-link(@click='() => $emit("openrules")', :class='{animate: pageLoaded}')
                    span.menu__item-text ПРАВИЛА

</template>

<script>
import {menu as menudata} from '@/assets/data/data.json';
import {mapGetters} from 'vuex';
export default {
    name: 'Menu',

    data() {
        return {
            menudata
        };
    },

    computed: {
        ...mapGetters(['pageLoaded'])
    },

    methods: {}
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';

@keyframes appearanceMenu {
    0% {
        opacity: 0;
        transform: translateY(100px) rotate(-90deg);
    }

    30% {
        opacity: 1;
        transform: translateY(100px) rotate(-90deg);
    }

    100% {
        transform: translateY(0px) rotate(-90deg);
    }
}

.menu {
    position: relative;
    z-index: 15;
    top: 0;
    left: 0;
    grid-column: 1;
    grid-row: 1;
    display: flex;
    pointer-events: none;

    @media (--viewport-tablet) {
        position: fixed;
        width: 100%;
        height: 100vh;
        transition: opacity 0.6s ease;
        grid-column: none;
        grid-row: none;

        &:before {
            content: '';
            position: absolute;
            z-index: 10;
            width: 100%;
            height: 100vh;
            top: 0;
            left: 0;
            display: inline-block;
            background: var(--color-bg-dark);
            transform: scaleY(0);
            transition: transform 0.6s ease-out;
            transform-origin: 0% 100%;
        }
    }

    &__list {
        position: absolute;
        left: -11.255em;
        top: 0;
        display: flex;
        justify-content: space-between;
        transform: rotate(-90deg);
        transform-origin: right top;
        line-height: 1;
        z-index: 15;
        font-family: var(--font-main);
        pointer-events: all;

        @media (--viewport-tablet) {
            position: relative;
            left: 0;
            display: block;
            margin: auto 16vw auto;
            height: auto;
            transform: none;
            line-height: normal;
            pointer-events: none;
        }
    }

    &__item {
        font-size: 1em;
        cursor: pointer;

        @media (--viewport-tablet) {
            font-size: 2em;
            margin-top: 0px;
            margin-bottom: 15px;
        }

        &:nth-child(2) {
            .menu__item-link {
                transition: opacity 0.6s ease 3s, transform 1.6s ease-out 2.5s;
            }
        }

        &:nth-child(2) {
            margin-right: 20px;
        }

        &:nth-child(1) {
            display: none;

            @media (--viewport-tablet) {
                display: inline-block;
            }
        }

        &-link {
            display: inline-block;
            vertical-align: bottom;
            overflow: hidden;
            color: black;
            opacity: 0;
            transform: translateX(-20px);
            transition: opacity 0.6s ease 3.2s, transform 1.6s ease-out 2.8s;

            &.animate {
                opacity: 1;
                transform: translateX(0px);
            }

            @media (--viewport-tablet) {
                color: white;
            }
        }

        &-index {
            display: inline-block;
            margin-right: 20px;
        }

        &-text {
            display: inline-block;
            @media (--viewport-tablet) {
                transform: translateY(120%);
            }
        }

        &-index,
        &-text {
            transition: transform 0.2s ease-in;
        }
    }

    &.active {
        @media (--viewport-tablet) {
            &:before {
                transform: scaleY(1);
                transition: transform 0.6s cubic-bezier(0.215, 0.61, 0.355, 1);
            }
        }

        .menu {
            &__list {
                @media (--viewport-tablet) {
                    pointer-events: all;
                }
            }

            &__item {
                &-index,
                &-text {
                    transform: translateY(0);
                }

                &:nth-child(1) {
                    .menu__item {
                        &-index,
                        &-text {
                            transition: transform 0.8s cubic-bezier(0.215, 0.61, 0.355, 1) 0.3s;
                        }
                    }
                }

                &:nth-child(2) {
                    .menu__item {
                        &-index,
                        &-text {
                            transition: transform 0.8s cubic-bezier(0.215, 0.61, 0.355, 1) 0.2s;
                        }
                    }
                }

                &:nth-child(3) {
                    .menu__item {
                        &-index,
                        &-text {
                            transition: transform 0.8s cubic-bezier(0.215, 0.61, 0.355, 1) 0.1s;
                        }
                    }
                }

                &:nth-child(4) {
                    .menu__item {
                        &-index,
                        &-text {
                            transition: transform 0.8s cubic-bezier(0.215, 0.61, 0.355, 1);
                        }
                    }
                }
            }
        }
    }
}
</style>
